import { faArrowUpBigSmall } from '@fortawesome/pro-light-svg-icons'
import { HeaderElementTask } from '..'
import { UpdateTaskTy } from '../../types'

interface HeaderTaskTransformTaskParentProps {
    id: string
    message: string
    updateTask: UpdateTaskTy
}

const HeaderTaskTransformTaskParent: React.FC<HeaderTaskTransformTaskParentProps> = ({ id, updateTask, message }) => {
    return (
        <HeaderElementTask id={'transformTaskParent_' + id} message={message} icon={faArrowUpBigSmall} onClick={() => updateTask('TaskId', null as any)} />
    )
}

export default HeaderTaskTransformTaskParent